import { ReactNode } from 'react';
import store from '../../store/configureStore';
import { defaultNotification, successNotification, warningNotification, dangerNotification } from './store/actions';

class Notifications {
	static default(content: ReactNode, config?) {
		store.dispatch(defaultNotification(content, config));
	}

	static success(content: ReactNode, config?) {
		store.dispatch(successNotification(content, config));
	}

	static warning(content: ReactNode, config?) {
		store.dispatch(warningNotification(content, config));
	}

	static danger(content: ReactNode, config?) {
		store.dispatch(dangerNotification(content, config));
	}
}

declare global {
	interface Window {
		ReactNotifications: Notifications;
	}
}

window.ReactNotifications = Notifications;

export { Notifications };
